<template>
    <div class="w-full border-b border-divider" />
</template>
